import jquery from 'jquery';
import _isUndefined from 'lodash/isUndefined';
import lodashTemplate from 'lodash/template';

import _Singleton, { deferredSingletonExport } from '@/tools/singleton';

import optionDefaultTemplate from '../ui/templates/option-default.js';
import optionSelectImageTemplate from '../ui/templates/option-select-image.js';
import optionSelectTemplate from '../ui/templates/option-select.js';
import optionRadioTemplate from '../ui/templates/option-radio.js';
import optionSpanTemplate from '../ui/templates/option-span.js';
import optionPreviewTemplate from '../ui/templates/option-preview.js';
import optionPreviewTextTemplate from '../ui/templates/option-preview-text.js';
import searchDefaultTemplate from '../ui/templates/search-default.js';

/**
 * @class
 *
 * @description
 * Обертка для шаблонизатора
 */
var Template = function () {
  var self = this;

  // грузим дефолтные шаблоны
  self._templateList = {
    'option-default': optionDefaultTemplate,
    'option-select-image': optionSelectImageTemplate,
    'option-select': optionSelectTemplate,
    'option-radio': optionRadioTemplate,
    'option-span': optionSpanTemplate,
    'option-preview': optionPreviewTemplate,
    'option-preview-text': optionPreviewTextTemplate,
    'search-default': searchDefaultTemplate
  };

  //  устанавливаем lock пока не собирем все шаблоны``
  self.lock = true;
  //  устанавливаем статус пусто
  self.empty = true;

  self._init();

  return self;
};

/**
 * @private
 * @param {*} template — функция или { html, compile }
 */
Template.prototype._compileTemplate = function (template, templateData, template_id) {
  var result = '';

  if (_isUndefined(template)) {
    return result;
  }

  try {
    if (template.html) {
      result = template.compile(templateData);
    } else {
      result = template(templateData);
    }
  } catch (e) {
    console.warn(e);
    console.warn('Ошибка рендера шаблона: ' + template_id + '. Проверьте корректность шаблона');
  }

  return result;
};

/**
 * @description
 * Генерация фрагмента нужного шаблона с данными
 *
 * @param {Object} templateData - информация для шаблонизатора
 * @param {string} template_id - названи
 *
 * @return {string} html
 *
 * TODO: тут был html|false
 *
 * @example
 * $(targetNode).html(Template.render({ title: 'Click me!' }, 'test-button' ));
 */
Template.prototype.render = function (templateData, template_id) {
  var self = this;
  var template = self.getTemplate(template_id);

  if (!_isUndefined(template)) {
    return self._compileTemplate(template, templateData, template_id);
  }

  if (self._retry(template_id)) {
    template = self.getTemplate(template_id);

    return self._compileTemplate(template, templateData, template_id);
  }

  console.warn(
    'Template: ',
    template_id,
    ' не подключен. Проверьте вызовы Template.render. Метод render корректно работает только после события DOMContentLoaded.'
  );

  return '';
};

/**
 * @description
 * Загрузка нового шаблона в список
 *
 * @param {string} template_body - верстка шаблона
 * @param {string} template_id - название шаблона
 *
 * @return {NULL} - ничего не возвращает.
 *
 * @example
 * Template.load('<button class="button button--click_me"><%= title %></button>', 'test-button')
 */
Template.prototype.load = function (template_body, template_id) {
  var self = this;

  try {
    // Если у клиента кастомные lodash-шаблоны и подключен lodash, то при загрузке шаблона прокидываем в него lodash из window.
    if (window._ && template_body.includes('_.')) {
      self._templateList[template_id] = lodashTemplate(template_body, { imports: { _: window._ } });
    } else {
      self._templateList[template_id] = lodashTemplate(template_body);
    }
  } catch (e) {
    console.error(e);
    console.error('Lodash template error: ' + template_id);
  }

  return;
};

/**
 * @description
 * Загрузка скомпилированного шаблона в список
 *
 * @param {string} compiledTemplate - скомпилированный шаблон
 * @param {string} template_id - название шаблона
 *
 * @return {NULL} - ничего не возвращает.
 */
Template.prototype.addCompiled = function (compiledTemplate, template_id) {
  var self = this;

  self._templateList[template_id] = compiledTemplate;

  return;
};

/**
 * @private
 *
 * @description
 * Инициализация. Собирает все имеющиеся в DOM шаблоны и подключает их
 *
 * @return {void}- ничего.
 */
Template.prototype._init = function () {
  var self = this;

  //self._setDefault();

  // ориентируемся на куски <script data-template-id="same-tamplete" />
  document.addEventListener('DOMContentLoaded', function (event) {
    var $templates = jquery('[data-template-id]');

    if ($templates.length) {
      $templates.each(function (index, template) {
        self.load(jquery(template).html(), jquery(template).data('templateId'));

        if (jquery(template).is(':last')) {
          //  снимаем lock
          self.lock = false;
          //  обновляем статус
          self.empty = false;
        }
      });
    }
    else {
      //  снимаем lock
      self.lock = false;
      //  обновляем статус
      self.empty = true;
    }
  });
};

/**
 * Проверяем, подключен ли указанный шаблон
 * @method
 * @private
 *
 * @param {string} template_id - название шаблона
 *
 * @return {Boolean} - подключен ли такой шаблон в системе?
 */
Template.prototype.has = function (template_id) {
  var self = this;
  var _has = false;

  if (!Template.empty || self._templateList[template_id]) {
    _has = true;
  }

  return _has;
};

//Template.prototype._setDefault = _defaultTemplates;

/**
 * @description
 * Повторная попытка получить шаблон из DOM по прямому вызову.
 *
 * @param {String} template_id - название шаблона
 *
 * @return {Boolean} - получилось ли прочитать шаблон?
 */
Template.prototype._retry = function (template_id) {
  var self = this;
  var result = false;

  var _template = jquery('[data-template-id="' + template_id + '"]');

  if (_template.length) {
    self.load(_template.html(), template_id);
    result = true;
  }

  return result;
};

/**
 * @description
 * Читаем шаблон из подключенных к системе
 *
 * @param {String} template_id - название шаблона
 *
 * @return {function} - шаблон
 */
Template.prototype.getTemplate = function (template_id) {
  var self = this;
  var _template = null;

  _template = self._templateList[template_id];

  return _template;
};

export default deferredSingletonExport(_Singleton(Template), Template);
